import './reset.css'
import './fonts.css'
import './theme.css'

export function AppLayout({ children }) {
  return <main>{children}</main>
}
